import { useNavigate } from "@tanstack/react-router";
import { type MouseEvent, useCallback } from "react";
import { ARTICLES, articleNav, articleRoutePath } from "@/platform/compendium";
import { isPlainNavClick } from "@/platform/lib/nav";

// The TheCore Compendium landing (/thecore): TheCore's findable home. A short identity intro (light TheCore
// identity in content, not a brand reskin), then the Articles as cards in nav order derived from the
// manifest, then a footer slot for install / community links. The intro copy is a minimal editorial
// draft; the footer's link targets are added once the maintainer verifies them. Head-only prerendered
// (the crawlable prose lives in the Articles this routes to).
export function CompendiumLanding() {
  const navigate = useNavigate();
  const go = useCallback(
    (to: string) => (e: MouseEvent) => {
      if (isPlainNavClick(e)) {
        e.preventDefault();
        navigate({ to } as Parameters<typeof navigate>[0]);
      }
    },
    [navigate],
  );
  return (
    <main className="compendium-landing">
      <section className="compendium-intro">
        <h1 className="compendium-intro-title">TheCore</h1>
        <p className="compendium-intro-lede">
          A StarCraft II hotkey layout focused on ergonomics and efficiency.
        </p>
      </section>

      <ul className="compendium-article-list">
        {articleNav(ARTICLES).map((article) => {
          const to = articleRoutePath(article.slug);
          return (
            <li key={article.slug}>
              <a href={to} className="compendium-article-card" onClick={go(to)}>
                <span className="compendium-article-title">{article.title}</span>
                <span className="compendium-article-desc">{article.description}</span>
              </a>
            </li>
          );
        })}
      </ul>

      <footer className="compendium-footer">
        {/* Install guide and community (Discord) links land here once the maintainer verifies the
            canonical invite; the slot ships now, the targets are editorial. */}
        <p className="compendium-footer-note"></p>
      </footer>
    </main>
  );
}
